import AttendanceSerializer from './base';

export default class BehaviourIncident extends AttendanceSerializer {
  normalize(model, hash, prop) {
    let defaults = {
      category: 0,
      entryNote: '',
      outcome: 0,
      status: 0,
      type: 0,
    };
    Object.assign(defaults, hash);
    hash = defaults;
    return super.normalize(model, hash, prop);
  }
}
